import React from 'react';

// Catches a crash in one page so the rest of the app keeps working, and shows a way back
// instead of a blank screen. Give it a key (for example the URL) so opening the page again starts fresh.
export default class PageErrorBoundary extends React.Component {
  constructor(props) { super(props); this.state = { error: null }; }
  static getDerivedStateFromError(error) { return { error }; }
  componentDidCatch(error, info) { console.error('Page crashed', error, info?.componentStack); }
  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div style={{ padding: 40, maxWidth: 640, margin: '0 auto', fontFamily: 'Roboto, sans-serif' }}>
        <h2 style={{ marginTop: 0 }}>{this.props.title || 'This page hit a problem'}</h2>
        <p style={{ color: '#555' }}>Something on this page did not load. Your data is safe. Try again, or go back.</p>
        <div style={{ display: 'flex', gap: 8 }}>
          <button type="button" onClick={() => this.setState({ error: null })} style={btn}>Try again</button>
          {this.props.backTo && <a href={this.props.backTo} style={{ ...btn, textDecoration: 'none' }}>Back</a>}
        </div>
      </div>
    );
  }
}
const btn = { padding: '8px 14px', borderRadius: 6, border: '1px solid #B8962E', background: '#B8962E', color: '#fff', fontWeight: 700, cursor: 'pointer' };
